
import { Component, Vue } from 'vue-property-decorator'
import { CompanyRechargeClient } from '@/api'
import CompanyRechargeEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'
import moment from 'moment'
type RowInfo = {row:any, rowIndex:number}
@Component({
  name: 'StationList',
  components: {
    CompanyRechargeEditor
  },
  filters: {
    formatStatus(status: string) {
      type StatusType = {
        [key: string]: string;
      };
      const statusMap: StatusType = {
        waiting: '等待中',
        agreed: '已同意',
        refused: '已拒绝',
        revoked: '已撤销'
      }
      return statusMap[status]
    }
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new CompanyRechargeClient()
    this.listQuery = {
      filter: {
        where: {
          description: { like: '' },
          status: 'waiting',
          createdAt: { begin: this.getFirstDayOfCurrentMonth(), end: this.getLastDayOfCurrentMonth() }
        },
        fields: {
          id: true,
          companyId: true,
          amount: true,
          discount: true,
          description: true,
          status: true,
          createdAt: true
        },
        include: [{ relation: 'company' }],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['updatedAt desc', 'createdAt desc']
      }
    }
  }

  async created() {
    super.created()
  }

  getFirstDayOfCurrentMonth() {
    const date = new Date()
    date.setDate(1)
    return date
  }
  getLastDayOfCurrentMonth() {
    const date = new Date()
    let currentMonth = date.getMonth()
    const nextMonth = ++currentMonth
    const nextMonthFirstDay:any = new Date(date.getFullYear(), nextMonth, 1)
    const oneDay = 1000 * 60 * 60 * 24
    return new Date(nextMonthFirstDay - oneDay)
  }

  tableRowClassName(r:RowInfo) {
    if (r.row.status === 'waiting') {
      return 'waiting-row'
    } else if (r.row.status === 'agreed') {
      return 'agreed-row'
    } else if (r.row.status === 'refused') {
      return 'refused-row'
    } else if (r.row.status === 'revoked') {
      return 'revoked-row'
    }
    return ''
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    const and = []
    if (!(_.isNil(t.filter.where.companyId) && _.isEmpty(t.filter.where.companyId))) {
      and.push({ description: { like: `%${t.filter.where.description.like}%` } })
    }

    const createdAt = t.filter.where.createdAt
    if (createdAt.begin) {
      and.push({ createdAt: { gte: moment(createdAt.begin).utcOffset(480) } })
    }

    if (createdAt.end) {
      and.push({ createdAt: { lt: moment(createdAt.end).utcOffset(480) } })
    }

    if (!_.isNil(t.filter.where.status) && !_.isEmpty(t.filter.where.status)) {
      and.push({ status: t.filter.where.status })
    }
    t.filter.where = { and }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val: number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val: number) {
    super.handleCurrentChange(val)
  }

  protected async handleAgree(row: any) {
    const self = this
    const client = self.client as CompanyRechargeClient
    this.$confirm('此操作将同意该充值申请, 向该账户充值，是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonClass: 'el-button--danger',
      type: 'warning'
    }).then(async() => {
      await client.agree(row.id)
      this.getList()
      this.$notify({
        title: '成功',
        message: '充值成功',
        type: 'success',
        duration: 2000
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '未进行任何操作'
      })
    })
  }

  protected handleRefuse(row: any) {
    const self = this
    const client = self.client as CompanyRechargeClient
    this.$confirm('此操作将拒绝该充值申请, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonClass: 'el-button--danger',
      type: 'warning'
    }).then(async() => {
      await client.refuse(row.id)
      this.getList()
      this.$notify({
        title: '成功',
        message: '成功拒绝了此次充值申请',
        type: 'success',
        duration: 2000
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '未进行任何操作'
      })
    })
  }
}
